module.exports = __webpack_public_path__ + "static/media/img1-tc-desktop.60c69094.png";